import React, { useRef, useState } from 'react';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { Galleria } from 'primereact/galleria';
import FileService from '../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import Constants from '../constants/Constants';
import { Dialog } from 'primereact/dialog';
import { Exhibition } from '../pages/exhibition/Exhibition';

const CustomExhibitions = (props) => {

    console.log("CustomExhibitions", props)

    const [activeIndex, setActiveIndex] = useState(0);


    const galleriaRef = useRef(null);


    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    const itemTemplate = (item) => {
        return <div className='flex justify-content-center w-12 align-items-center flex-column'>
            <img src={FileService.inquireFilePath(item?.headerimageData?.file)} alt={"header"} style={{ maxWidth: 500, maxHeight: 600, display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />
            <div className={'text-3xl  font-700-regular pt-3 font-white'}>
                {item.exhibitionName}

            </div>

        </div>;
    }

    const thumbnailTemplate = (item) => {
        return <img src={FileService.inquireFilePath(item.file)} alt={item.name} style={{ display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />;
    }


    return (
        <div >
            <Galleria ref={galleriaRef} value={props.exhibits} responsiveOptions={responsiveOptions} numVisible={7} style={{ maxWidth: '850px' }}
                activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                circular fullScreen showItemNavigators showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />

            <div className="grid" style={{ padding: '1.5rem 2rem' }} >
                {
                    props.exhibits && props.exhibits.map((exhibit, index) => {
                        let imgEl =
                            <div className='art-images' style={{
                                backgroundImage: `url(${FileService.inquireFilePath(exhibit?.headerimageData?.file)})`,
                            }}
                                onClick={
                                    () => {
                                        //  props.onAction(0);

                                        props.onSelectedExhibit(exhibit);

                                    }
                                } >
                                <div style={{
                                    flexDirection: 'row',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: 10,
                                    zIndex: 11933
                                }}
                                >
                                    {
                                        Constants.fileTypes.artwork != exhibit.filterType &&
                                        <div style={{
                                            flexDirection: 'row',
                                            display: 'flex',
                                            background: 'rgba(255, 255, 255, 0.65)',
                                            boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                                            borderRadius: 20,
                                            backdropFilter: 'blur(5px)',
                                            alignItems: 'center',
                                            paddingRight:8,
                                            paddingLeft:8

                                        }}>
                                            <img style={{ width: 25, height: 25, borderRadius: 30 }} src={FileService.inquireFilePath(exhibit.profileImage)} />
                                            <div style={{ paddingLeft: 5, color: 'black', fontSize: 14, fontWeight: '400', wordWrap: 'break-word', textAlign: 'center' }}>
                                                {exhibit.firstName + " " + exhibit.lastName } </div>
                                        </div>
                                    }
                                    {
                                        Constants.fileTypes.artwork == exhibit.filterType &&
                                        <div></div>
                                    }
                                    <div style={{
                                        flexDirection: 'row',
                                        display: 'flex',
                                        background: 'rgba(255, 255, 255, 0.65)',
                                        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                                        backdropFilter: 'blur(5px)',
                                        borderRadius: 20,
                                        alignItems: 'right'

                                    }}>
                                        <Button icon="fa-regular fa-heart" className={exhibit?.favoriteId ? "p-button-rounded " : "p-button-rounded p-button-header "}
                                            style={{
                                                backdropFilter: 'blur(5px)',

                                            }}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                if (exhibit.favoriteId)
                                                    props.onRemoveFavorite(exhibit);
                                                else
                                                    props.onAddFavorite(exhibit, Constants.entityNames.exhibition)
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>

                        return (
                            <div className='m-2 mb-6' key={index}>
                                <div className='text-center' style={{ borderRadius: 20, width: 275, height: 225 }}>

                                    {imgEl}
                                </div>
                                <div className='text-2xl  font-400-regular pt-3 ' style={{
                                    ...props.labelStyle
                                }}>
                                    {exhibit.exhibitionName}
                                </div>
                            </div>
                        )
                    })
                }
                {
                    props.RenderAddPanel && props.RenderAddPanel()
                }



            </div>
        </div>
    );
};

export default CustomExhibitions;
